import React from "react";
import { Check, AlertTriangle } from "lucide-react";
import { ENGLISH_TESTS } from "./hcaData";
import { HcaReveal, HcaEyebrow } from "./HcaReveal";

const REQS = [
    "Grade 10 completion (or equivalent), or mature student status (19+)",
    "Proof of English language competency (see accepted tests)",
    "Clear police certificate from country of origin (international applicants)",
    "BC criminal record check before clinical placement",
];

export const HcaAdmissions = () => (
    <section data-testid="hca-admissions-section" className="bg-white border-y border-[#D8DEE6]">
        <div className="max-w-7xl mx-auto px-6 py-20 lg:py-28 grid lg:grid-cols-12 gap-12">
            <HcaReveal className="lg:col-span-5">
                <HcaEyebrow>Who can apply</HcaEyebrow>
                <h2 className="font-display text-3xl sm:text-4xl text-[#0E1E3A] mt-3 leading-tight">Entry requirements</h2>
                <ul className="mt-8 space-y-4">
                    {REQS.map((r) => (
                        <li key={r} className="flex gap-3 text-[#0E1E3A]">
                            <Check className="h-5 w-5 text-[#2E6F40] shrink-0 mt-0.5" /> <span className="text-sm leading-relaxed">{r}</span>
                        </li>
                    ))}
                </ul>
                <div className="mt-8 rounded-xl border border-amber-300 bg-amber-50 p-4 flex gap-3" data-testid="hca-disclaimer">
                    <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0" />
                    <p className="text-xs text-amber-900 leading-relaxed">
                        This program is <strong>not eligible for the Post-Graduation Work Permit (PGWP)</strong>. Heritage
                        Community College does not handle immigration or visa services.
                    </p>
                </div>
            </HcaReveal>
            <HcaReveal delay={0.1} className="lg:col-span-7">
                <div className="rounded-2xl bg-[#F9F8F6] border border-[#D8DEE6] p-6 sm:p-8" data-testid="hca-english-table">
                    <h3 className="font-display text-xl text-[#0E1E3A]">Accepted English tests</h3>
                    <p className="text-sm text-[#5E6B7E] mt-1">Required if you have fewer than 3 years of full-time English instruction. Tests within the last 2 years (CLB: last year).</p>
                    <dl className="mt-6 divide-y divide-[#D8DEE6]">
                        {ENGLISH_TESTS.map(([t, s]) => (
                            <div key={t} className="py-3.5 grid sm:grid-cols-5 gap-1 sm:gap-4">
                                <dt className="sm:col-span-2 text-sm font-semibold text-[#0E1E3A]">{t}</dt>
                                <dd className="sm:col-span-3 text-sm text-[#5E6B7E]">{s}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </HcaReveal>
        </div>
    </section>
);
